export const camelCaseToDash = (value: string) => {
  return value.replace(/([a-z])([A-Z])/g, '$1-$2').toLocaleLowerCase()
}

export const underlineToDash = (value: string) => {
  return value.replace(/_/g, '-').toLowerCase()
}

export const capitalizeFirstLetter = (text: string) => text.charAt(0).toUpperCase() + text.slice(1)

export const getFunctionName = (func: Function) => (func.name.length > 0 ? func.name : '')

export const stringToUrl = (string: string) => new URL(string.includes(':') ? string : 'http://' + string)

export const isValidHttpUrl = (string: string) => {
  if (!/.\../i.test(string) || string.includes(' ')) return false
  let url
  try {
    url = stringToUrl(string)
  } catch (e) {
    return false
  }
  return url.protocol === 'http:' || url.protocol === 'https:'
}
